import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=3dff8486&scoped=true"
import script from "./Logout.vue?vue&type=script&lang=ts"
export * from "./Logout.vue?vue&type=script&lang=ts"
import style0 from "./Logout.vue?vue&type=style&index=0&id=3dff8486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dff8486",
  null
  
)

export default component.exports